import { css } from '@emotion/react'
import common from 'shared/styles'

const styles = () => {
    return {
        main: css`
            ${common.fullContainer};
            display: flex;
            flex-direction: column;
            padding-left: 30px;
        `,
        actions: css`
            align-self: flex-start;
            flex-grow: 2;
        `,
    }
}

export default styles
